import React from "react";
import FacultyDiscussionBoardSection from "./Board";


export default function FacultyCurrentDashboardItem({ dashboard, userProfile, deliverable }) {

  return (
    <div
      style={{
        padding: "1rem 0",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column",
        width: "100%",
        height: "100%",
      }}
    >
      <div style={{ width: "100%", marginTop: "1rem" }}>
        <FacultyDiscussionBoardSection
          userProfile={userProfile}
          idDashboard={dashboard.id}
          idDeliverable={(deliverable || {}).id}
        />
      </div>
    </div>
  );
}